import { RemoteLoginAccountCognito } from 'infra/http/cognito/remote-login-account-cognito'
import { LoginAccountService } from 'infra/services/login-account-service'
import { makeAccessTokenCache } from '../cache/set-access-token-cache-factory'
import { makeUserService } from './user-service-factory'

export const makeLoginAccountService = (): LoginAccountService =>
  new LoginAccountService(new RemoteLoginAccountCognito(), makeAccessTokenCache(), makeUserService())
